<div style="display: flex;margin-left: -13px;margin-top: -20px;">
  <div style="margin-right: 30px;margin-top: -8px;">
    <div>
      <mat-slide-toggle color="primary" labelPosition="before" [(ngModel)]="viewModel.runDataTypeConverter">Run Data Type Converter</mat-slide-toggle>
    </div>

    <div>
      <mat-slide-toggle color="primary" labelPosition="before" [(ngModel)]="viewModel.ingestOnFail">Upon fail, ingest without conversion</mat-slide-toggle>
    </div>
  </div>

  <div style="margin-left: -75px; margin-top: -20px;">
    <div>
      <mat-form-field>
        <mat-label>Duration field units</mat-label>
        <mat-select [(ngModel)]="viewModel.durationUnits">
          <mat-option *ngFor="let type of DurationUnitTypes" [value]="type">
              {{DurationUnitsUtil.toString(type)}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>  
</div>

  
  
     
  